import { useEffect } from "react";
import cn from "classnames";
import { useTimers } from "@utils/hooks/useTimer";

import styles from "./TimerBlock.module.scss";
import { useDispatch } from "react-redux";
import { calcTimersAction } from "@store/timer/actions";
import { useIntl } from "react-intl";

export default function TimerBlock() {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const timers = useTimers(0);

  //если какой-то из локальных
  useEffect(() => {
    if (typeof timers === "number" || Object.keys(timers).length < 1) return;

    const int = setInterval(() => {
      dispatch(calcTimersAction(timers));
    }, 1000);

    return () => clearInterval(int);
  }, [timers]);

  if (typeof timers !== "number" && timers[0] > 0) {
    if (!timers) {
      return null;
    } else {
      return (
        <div
          className={styles.wrapper}
          title={formatMessage({ id: "notifications.info.timer.title" })}
        >
          <span>{timers[0]}</span>
        </div>
      );
    }
  }

  return null;
}
